import axios from 'axios'
import CONFIG from '../../config'
const _ = require('lodash')

export async function getCentersList (name, page, token, currentLocation) {
  const config = {
    headers: {
      Authorization: 'Bearer ' + token
    }
  }
  let queryParams
  if (name) queryParams = `clinics/?name=${name}&page=${page}`
  else if (currentLocation?.lat && currentLocation?.lng) queryParams = `clinics/?lat=${currentLocation.lat}&lng=${currentLocation.lng}`

  try {
    if (queryParams) {
      const { data } = await axios.get(`${CONFIG.api_url}/${queryParams}`, config)
      if (_.isEmpty(data)) return { results: [], totalPages: 0 }
      return data
    }
  } catch (error) {
    console.log(error.message)
    if (error.response.status === 401) {
      return { status: 'Unauthorized' }
    } else {
      return { results: [], totalPages: 0 }
    }
  }
}

export async function getCenterById (id, token) {
  const config = {
    headers: {
      Authorization: 'Bearer ' + token
    }
  }
  try {
    const { data } = await axios.get(`${CONFIG.api_url}/clinic/?id=${id}`, config)
    if (data) {
      return data
    } return ''
  } catch (error) {
    console.log(error.message)
    if (error.response.status === 401) {
      return { status: 'Unauthorized' }
    } else {
      return { status: 'Failed', message: error.message }
    }
  }
}

export async function updateCenter (token, payload) {
  const config = {
    headers: {
      Authorization: 'Bearer ' + token
    }
  }

  try {
    const res = await axios.post(`${CONFIG.api_url}/update`, payload, config)
    if (res.status === 200) {
      return res.data
    } else return res
  } catch (error) {
    if (error.response.status === 401) {
      return { status: 'Unauthorized' }
    } else return { status: 'Failed', message: error.response.data.message }
  }
}
